module.exports = __webpack_public_path__ + "static/media/msg.311ef68f.mp3";